/* eslint-disable */
import React from 'react'

const Liabilities = () => {
    return (
        <div>Liabilities</div>
    )
}

export default Liabilities